export default __webpack_public_path__ + "static/media/D5753BC7-179F-40AA-AFFE-B1778A0701C3.96a8698b.jpg";